import React from "react";
import { useNavigate } from "react-router-dom";
import { caseState } from "@/lib/stages";
import { ukWhen } from "@/lib/time";
import { CellMain, CellSub, Empty, Money, Panel, StatusChip, Tag, Tb, Td, Th } from "@/components/portal/crm/kit";

/** Every case their system sent in — the same rows, stages and case record as My cases. */
export const ApiCases = ({ leads }) => {
  const nav = useNavigate();
  const rows = (leads || []).filter((l) => l.submitted_via === "api");
  return (
    <Panel pad={false} testId="api-cases-panel"
           footer={<span>These are in My cases too. The Connexis desk places each one by hand, so a person checks it before any lender sees it.</span>}>
      {rows.length === 0 ? (
        <Empty testId="api-cases-empty">Nothing in yet. The first case your system sends will appear here within seconds.</Empty>
      ) : (
        <Tb testId="api-cases-table" head={<><Th>Case</Th><Th>Amount</Th><Th>Stage</Th><Th className="r">Received</Th></>}>
          {rows.slice(0, 50).map((l) => (
            <tr key={l.id} style={{ cursor: "pointer" }} onClick={() => nav(`/introducer/cases/${l.id}`)} data-testid={`api-case-row-${l.id}`}>
              <td className="lead">
                <CellMain>{l.business_name || l.applicant_name}</CellMain>
                <CellSub>{l.reference}{l.api_external_id ? ` · your id ${l.api_external_id}` : ""}</CellSub>
                {l.duplicate_of && (
                  <div style={{ marginTop: 6 }} data-testid={`api-case-duplicate-${l.id}`}
                       title="You've sent this client before — the desk will check before placing it">
                    <Tag amber>Possible duplicate · same {(l.duplicate_reason || "email").replace("+", " & ")}</Tag>
                  </div>
                )}
              </td>
              <Td><Money v={l.amount_gbp} sub={l.finance_type} /></Td>
              <Td><StatusChip state={caseState(l)} testId={`api-case-stage-${l.id}`} /></Td>
              <Td className="r"><CellSub>{ukWhen(l.created_at)}</CellSub></Td>
            </tr>
          ))}
        </Tb>
      )}
    </Panel>
  );
};

/** The calls their system made, newest first. */
export const ApiActivity = ({ rows = [] }) => (
  <Panel title="Recent calls" testId="api-activity-panel" sub="What your system asked us, and what we answered.">
    {rows.length === 0 ? (
      <Empty testId="api-activity-empty">No calls yet.</Empty>
    ) : (
      <div style={{ display: "grid", gap: 7 }} data-testid="api-activity-log">
        {rows.slice(0, 12).map((r) => (
          <div key={r.id} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 12.5, color: "var(--mut)", flexWrap: "wrap" }}>
            <Tag amber={r.status >= 400}>{r.status}</Tag>
            <span style={{ fontWeight: 700, color: "var(--ink)" }}>{r.method} {r.path}</span>
            {r.reference && <span>{r.reference}</span>}
            {r.duplicate && <Tag amber>flagged duplicate</Tag>}
            <span style={{ marginLeft: "auto", fontVariantNumeric: "tabular-nums" }}>{ukWhen(r.at)}</span>
          </div>
        ))}
      </div>
    )}
  </Panel>
);
